export const safelyParseJSON = (json: unknown, fallback = null) => {
  if (typeof json !== 'string' || !json) return fallback;

  try {
    return JSON.parse(json);
  } catch (e) {
    console.error(e);

    return fallback;
  }
};
